import { Box } from '@mui/material';
import AlertIcon from './AlertIcon';
import AlertMessageStyles from './AlertMessage.styles';
import AlertText from './AlertText';
import { AlertMessageProps } from './types';
import useAlertConfig from './useAlertConfig';

/**
 * AlertMessage Component
 *
 * Displays an alert message with an icon and text based on the action type.
 * Supports approve, reject, and expire actions with customizable promoter name.
 *
 * @param action - The type of action (approve, reject, expire)
 * @param promoterName - Optional promoter name, defaults to "John Doe"
 */
const AlertMessage = ({ action, promoterName }: AlertMessageProps) => {
  const { config, finalPromoterName } = useAlertConfig(action, promoterName);

  return (
    <Box
      component="section"
      role="alert"
      aria-live="polite"
      className={AlertMessageStyles.container}
    >
      <AlertIcon action={action} config={config} />
      <AlertText config={config} promoterName={finalPromoterName} />
    </Box>
  );
};

export default AlertMessage;
